// BACKEND INTEGRATION POINT: Replace with DB fetch from app_settings table
export const APP_CONFIG = {
  appName: 'NEUROMINER',
  appShortName: 'NM',
  appDescription: 'GPU Compute Passive Income Platform',
  primaryColor: '#3977FF',
  secondaryColor: '#6EA8FF',
  accentColor: '#8B5CF6',
  supportEmail: 'support@neurominer.io',
  supportUrl: 'https://neurominer.io/support',
  maintenanceMode: false,
  registrationEnabled: true,
  withdrawalsEnabled: true,
  depositsEnabled: true,
  referralEnabled: true,
  boostEnabled: true,
  nftEnabled: true,
  energyEnabled: true,
  minWithdrawal: 10,
  maxWithdrawal: 10000,
  withdrawalFee: 1,
  minDeposit: 10,
};

export const NETWORKS = {
  BSC: {
    id: 'bsc',
    name: 'BSC',
    fullName: 'BNB Smart Chain',
    token: 'USDT',
    address: '0x58cD3ea0ce85D6bCe512CDF80A137eBc3C9c6E28',
    explorerUrl: 'https://bscscan.com/tx/',
    explorerAddressUrl: 'https://bscscan.com/address/',
    color: '#F3BA2F',
    enabled: true,
    minDeposit: 10,
    minWithdrawal: 10,
    withdrawalFee: 1,
    confirmations: 12,
  },
  TRON: {
    id: 'tron',
    name: 'TRON',
    fullName: 'TRC20',
    token: 'USDT',
    address: 'TKeX7PHiJ1Y8eBPQ2UPnUs8LnxcDZynKr8',
    explorerUrl: 'https://tronscan.org/#/transaction/',
    explorerAddressUrl: 'https://tronscan.org/#/address/',
    color: '#EF0027',
    enabled: true,
    minDeposit: 10,
    minWithdrawal: 10,
    withdrawalFee: 1,
    confirmations: 20,
  },
};

export const REFERRAL_LEVELS = {
  1: { percentage: 4, label: 'Level 1' },
  2: { percentage: 2, label: 'Level 2' },
  3: { percentage: 1, label: 'Level 3' },
};